// // src/components/IndustryDetails/IndustryDetails.jsx
// import React from 'react';
// import styles from './IndustryDetails.module.scss';

// export default function IndustryComplete({
//   industry,                // pass the full industry object from your dataset
//   outcomeIcon,             // optional icon src for the outcome list (PNG/SVG)
  
// }) {
//   console.log(industry);
  
//   if (!industry) return null;

//   const { strategies = []} = industry;
//   const outcomeTitle = industry.outcomeTitle || 'Industries Outcome';

  

//   const leftOutcome = industry.outcome.slice(0,3)
//   const rightOutcome = industry.outcome.slice(3)

//   const outcomeParagraph = industry.outcomeParagraph || '';
    
//   return (
//     <section className={`${styles.details} mt-5`}>
//       {/* Strategies */}
//       <div className={styles.block}>
//         <h3 className={styles.title}>Strategies</h3>
//         <ul className={styles.cards}>
//           {strategies.map((s, i) => (
//             <li key={i} className={styles.card}>
//               <img src={s.icon} alt={s.cardTitle} style={{height:'50px',marginBottom:'20px'}}></img>
//               <h4 className={styles.cardTitle}>{s.title}</h4>
//               <p className={styles.cardDesc}>{s.desc}</p>
//             </li>
//           ))}
//         </ul>
//       </div>

   

//       {/* Industries Outcome */}
//       <div className={`${styles.block} mt-5`}>
//         <h3 className={styles.title}>{outcomeTitle}</h3>
        
//         <p className={styles.paragraph} dangerouslySetInnerHTML={{ __html: outcomeParagraph }} />

//         <div className={styles.twoCol}>
//           <ul className={styles.iconList}>
//             {leftOutcome.map((text, i) => (
//               <li key={i} className={styles.iconItem}>
//                 {outcomeIcon
//                   ? <img className={styles.iconImg} src={outcomeIcon} alt="" aria-hidden="true" />
//                   : <span className={styles.iconFallback} aria-hidden="true">✓</span>}
//                 <span className={styles.iconText}>{text}</span>
//               </li>
//             ))}
//           </ul>

//           <ul className={styles.iconList}>
//             {rightOutcome.map((text, i) => (
//               <li key={i} className={styles.iconItem}>
//                 {outcomeIcon
//                   ? <img className={styles.iconImg} src={outcomeIcon} alt="" aria-hidden="true" />
//                   : <span className={styles.iconFallback} aria-hidden="true">✓</span>}
//                 <span className={styles.iconText}>{text}</span>
//               </li>
//             ))}
//           </ul>
//         </div>
//       </div>
//     </section>
//   );
// }



// src/components/IndustryDetails/IndustryDetails.jsx
import React from 'react';
import styles from './IndustryDetails.module.scss';

export default function IndustryComplete({
  industry,                // pass the full industry object from your dataset
  outcomeIcon,             // optional icon src for the outcome list (PNG/SVG)
}) {
  console.log(industry);
  
  if (!industry) return null;

  const { strategies = []} = industry;
  const outcomeTitle = industry.outcomeTitle || 'Industries Outcome';

  const leftOutcome = industry.outcome.slice(0,3)
  const rightOutcome = industry.outcome.slice(3)

  const outcomeParagraph = industry.outcomeParagraph || '';
    
  return (
    <section className={`${styles.details} mt-5`}>
      {/* Strategies */}
      <div className={styles.block}>
        <h3 className={styles.title}>Strategies</h3>
        <ul className={styles.cards}>
          {strategies.map((s, i) => (
            <li key={i} className={styles.card}>
              <img src={s.icon} alt={s.title} style={{height:'50px',marginBottom:'20px'}}></img>
              <h4 className={styles.cardTitle}>{s.title}</h4>
              <p className={styles.cardDesc}>{s.desc}</p>
            </li>
          ))}
        </ul>
      </div>

      {/* Industries Outcome */}
      <div className={`${styles.block} mt-5`}>
        <h3 className={styles.title}>{outcomeTitle}</h3>
        
        <p className={styles.paragraph} dangerouslySetInnerHTML={{ __html: outcomeParagraph }} />

        <div className={styles.twoCol}>
          <ul className={styles.iconList}>
            {leftOutcome.map((text, i) => (
              <li key={i} className={styles.iconItem}>
                {outcomeIcon
                  ? <img className={styles.iconImg} src={outcomeIcon} alt="" aria-hidden="true" />
                  : <span className={styles.tickIcon} aria-hidden="true">✓</span>}
                <span className={styles.iconText}>{text}</span>
              </li>
            ))}
          </ul>

          <ul className={styles.iconList}>
            {rightOutcome.map((text, i) => (
              <li key={i} className={styles.iconItem}>
                {outcomeIcon
                  ? <img className={styles.iconImg} src={outcomeIcon} alt="" aria-hidden="true" />
                  : <span className={styles.tickIcon} aria-hidden="true">✓</span>}
                <span className={styles.iconText}>{text}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <style jsx>{`
        .iconItem {
          position: relative;
          padding: 10px 0 10px 32px;
          font-size: 0.95rem;
          line-height: 1.6;
          color: #555;
          border-bottom: 1px solid #f0f0f0;
        }
        
        .tickIcon {
          position: absolute;
          left: 0;
          top: 10px;
          color: #007bff;
          font-weight: bold;
          font-size: 1.1rem;
        }
        
        .iconItem:last-child {
          border-bottom: none;
        }
        
        /* Tablet and Mobile Responsive */
        @media (max-width: 768px) {
          .iconItem {
            padding: 8px 0 8px 28px;
            font-size: 0.9rem;
          }
          
          .tickIcon {
            top: 8px;
            font-size: 1rem;
          }
        }
        
        @media (max-width: 576px) {
          .iconItem {
            padding: 7px 0 7px 25px;
            font-size: 0.85rem;
          }
          
          .tickIcon {
            top: 7px;
            font-size: 1rem;
          }
        }
      `}</style>
    </section>
  );
}